import React from 'react';
import UnitsPage from './UnitsPage';

const SemiRemolquePage = () => {
  return <UnitsPage tipoUnidad="semi remolque" title="Semiremolques" />;
};

export default SemiRemolquePage;
